export default "__VITE_ASSET__679d5db7__"